import { useEffect, useState } from 'react';

import { FreespinsApi, useApplicationState } from '@atlas/core';

const {
  FreeSpinsStatus: { ACTIVATED, CANCELED, DISABLED, EXPIRED, USED },
} = FreespinsApi;

const STATUS_ORDER = {
  [ACTIVATED]: 1,
  [CANCELED]: 4,
  [DISABLED]: 3,
  [EXPIRED]: 5,
  [USED]: 2,
};

const DEFAULT_STATUSES = [ACTIVATED, USED, DISABLED, CANCELED, EXPIRED];

const useFreeSpins = ({ itemsPerPage = 100, statuses = DEFAULT_STATUSES } = {}) => {
  const { authenticated } = useApplicationState();

  const [freeSpins, setFreeSpins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const statusesKey = JSON.stringify(statuses);

  useEffect(() => {
    if (!authenticated) {
      setLoading(false);
      return;
    }

    const options = {
      filter: {
        freeSpinStatuses: JSON.parse(statusesKey),
      },
      paging: {
        itemsPerPage,
      },
    };

    setLoading(true);
    setError(null);

    FreespinsApi.getFreeSpins(options)
      .then(({ freeSpins }) => {
        const sortedFreeSpins = [...freeSpins].sort(
          (a, b) => STATUS_ORDER[a.status] - STATUS_ORDER[b.status],
        );

        setFreeSpins(sortedFreeSpins);
      })
      .catch(setError)
      .finally(() => setLoading(false));
  }, [authenticated, itemsPerPage, statusesKey]);

  return { error, freeSpins, loading };
};

export default useFreeSpins;
